const mycenter_index = () => import(/* webpackChunkName: "wap" */ '../mycenter/index');
const myCard_index = () => import(/* webpackChunkName: "wap" */ '../mycenter/myCard/index');
const myOrder_index = () => import(/* webpackChunkName: "wap" */ '../mycenter/myOrder/index');
const myPrize_index = () => import(/* webpackChunkName: "wap" */ '../mycenter/myPrize/index');
const interactionRecord_index = () => import(/* webpackChunkName: "wap" */ '../mycenter/interactionRecord/index');
const myAddress_index = () => import(/* webpackChunkName: "wap" */ '../mycenter/myAddress/index');
const cardDetails = () => import(/* webpackChunkName: "wap" */ '../mycenter/myCard/cardDetails');
const writeOffCard = () => import(/* webpackChunkName: "wap" */ '../mycenter/myCard/writeOffCard');
const Writeoff = () => import(/* webpackChunkName: "wap" */ '../mycenter/myOrder/Writeoff');
const yuYue = () => import(/* webpackChunkName: "wap" */ '../mycenter/myOrder/yuYue');
const prizeDetails = () => import(/* webpackChunkName: "wap" */ '../mycenter/myPrize/prizeDetails');
const money = () => import(/* webpackChunkName: "wap" */ '../mycenter/money.vue');
const money_data = () => import(/* webpackChunkName: "wap" */ '../mycenter/money_data.vue');
const indent_cardDetails = () => import(/* webpackChunkName: "wap" */ '../mycenter/myIndent/cardDetails');
const indent_writeOffCard = () => import(/* webpackChunkName: "wap" */ '../mycenter/myIndent/writeOffCard');
const database = () => import(/* webpackChunkName: "wap" */ '../database/index');


var wap_router = [
    {
        path: '/wap/mycenter/index',//会员中心首页
        name: '/wap/mycenter/index',
        meta: {title: '个人中心', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: mycenter_index,
      },
      {
        path: '/wap/mycenter/myCard/index',//会员中心-我的卡券
        name: '/wap/mycenter/myCard/index',
        meta: {title: '我的卡券', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: myCard_index,
      },
      {
        path: '/wap/mycenter/myOrder/index',//会员中心-我的订单
        name: '/wap/mycenter/myOrder/index',
        meta: {title: '我的订单', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: myOrder_index,
      },
      {
        path: '/wap/mycenter/myPrize/index',//会员中心-我的奖品
        name: '/wap/mycenter/myPrize/index',
        meta: {title: '我的奖品', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: myPrize_index,
      },
      {
        path: '/wap/mycenter/myPrize/prizeDetails',//会员中心-我的奖品详情
        name: '/wap/mycenter/myPrize/prizeDetails',
        meta: {title: '我的奖品', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: prizeDetails,
      },
      {
        path: '/wap/mycenter/interactionRecord/index',//会员中心-说一说记录
        name: '/wap/mycenter/interactionRecord/index',
        meta: {title: '说一说记录', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: interactionRecord_index,
      },
      {
        path: '/wap/mycenter/myAddress/index',//会员中心-我的地址
        name: '/wap/mycenter/myAddress/index',
        meta: {title: '我的地址', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: myAddress_index,
      },
      {
        path: '/wap/mycenter/myCard/cardDetails',//会员中心-卡券详情
        name: '/wap/mycenter/myCard/cardDetails',
        meta: {title: '卡券详情', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: cardDetails,
      },
      {
        path: '/wap/mycenter/myCard/writeOffCard',//会员中心-卡券核销
        name: '/wap/mycenter/myCard/writeOffCard',
        meta: {title: '卡券核销', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: writeOffCard,
      },
      {
        path: '/wap/mycenter/myOrder/Writeoff',//会员中心-预约核销
        name: '/wap/mycenter/myOrder/Writeoff',
        meta: { title: '预约核销', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0" },
        component: Writeoff,
      },
      {
        path: '/wap/mycenter/myOrder/yuYue',//会员中心-预约列表
        name: '/wap/mycenter/myOrder/yuYue',
        meta: { title: '预约列表', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0" },
        component: yuYue,
      },
      {
        path: '/wap/mycenter/money',//会员中心-预约列表
        name: '/wap/mycenter/money',
        meta: { title: '个人中心', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0" },
        component: money,
      },
      {
        path: '/wap/mycenter/money_data',//会员中心-预约列表
        name: '/wap/mycenter/money_data',
        meta: { title: '个人中心', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0" },
        component: money_data,
      },

      {
        path: '/wap/mycenter/myIndent/writeOffCard',//会员中心-订购核销
        name: '/wap/mycenter/myIndent/writeOffCard',
        meta: {title: '订购核销', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: indent_writeOffCard,
      },
      // {
      //   path: '/wap/mycenter/myIndent/Writeoff',//会员中心-订购核销
      //   name: '/wap/mycenter/myIndent/Writeoff',
      //   meta: { title: '订购核销', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0" },
      //   component: indent_Writeoff,
      // },

      {
        path: '/wap/mycenter/myIndent/cardDetails',//会员中心-订单详情
        name: '/wap/mycenter/myIndent/cardDetails',
        meta: {title: '订单详情', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: indent_cardDetails,
      },
    //资料库
    {
        path: '/wap/database/index',//会员中心首页
        name: '/wap/database/index',
        meta: {title: '素材助手', name: 'viewport', content: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0"},
        component: database,
    },
];


export {
    wap_router
  }



// WEBPACK FOOTER //
// ./src/wap/router/index.js